import { render, staticRenderFns } from "./PreferenceSetting.vue?vue&type=template&id=6861f7ec&scoped=true"
import script from "./PreferenceSetting.vue?vue&type=script&lang=js"
export * from "./PreferenceSetting.vue?vue&type=script&lang=js"
import style0 from "./PreferenceSetting.vue?vue&type=style&index=0&id=6861f7ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6861f7ec",
  null
  
)

export default component.exports